import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue.ts";
import { useEditRequestModals } from "@/features/request/edit/contexts/edit-request-modals.context";
import { feedbackToolKeys } from "@/hooks/queryKeys";
import { useIsTemplate } from "@/hooks/useIsTemplate.tsx";
import apiClient from "@/lib/api/client";

export function useDeleteFeedback(
  commentBatchId: string | undefined,
  parentId: number,
) {
  const queryClient = useQueryClient();
  const { isTemplate } = useIsTemplate();
  const { openUnlock } = useEditRequestModals();

  return useMutation({
    mutationFn: async () => {
      if (isTemplate) {
        return;
      }

      return await apiClient
        .url(`/stories/feedback-tool/${commentBatchId}`)
        .delete()
        .json();
    },
    mutationKey: feedbackToolKeys.delete(commentBatchId),
    onError: () => {
      toast.add(
        {
          description: "Please try to delete feedback again.",
          title: "Error deleting feedback",
          type: "error",
        },
        {
          timeout: 5000,
        },
      );
    },
    onSuccess: async () => {
      if (isTemplate) {
        openUnlock();

        return;
      }
      toast.add(
        {
          title: "Feedback deleted successfully",
          type: "success",
        },
        {
          timeout: 5000,
        },
      );
      await queryClient.invalidateQueries({
        queryKey: feedbackToolKeys.feedbacks(parentId),
      });
    },
  });
}
